module.exports = __webpack_public_path__ + "img/hm_block01_sc.6d0113c1.jpg";